import StaticDataV1 from './StaticDataV1';
import StaticDataV2 from './StaticDataV2';
import StaticDataV3 from './StaticDataV3';
import type { LondonProtocolStaticDataProps } from './staticDataSharedProps';

export type StaticDataVersionedProps = LondonProtocolStaticDataProps

const StaticDataVersioned = ({
    londonProtocol,
    context = 'individual',
    groupKeyDisplay = ''
}: StaticDataVersionedProps) => {
    const version = londonProtocol?.u_version
    console.log('Loading London Protocol version...', version)
    const common = { londonProtocol, context, groupKeyDisplay }
    switch (version) {
        case 'v1':
            return <StaticDataV1 {...common} />
        case 'v2':
            return <StaticDataV2 {...common} />
        case 'v3':
            return <StaticDataV3 {...common} />

        default:
            return <StaticDataV3 {...common} />
    }
}

export default StaticDataVersioned